(function () {
  if (window.__pvSectionsLoaded) return;
  window.__pvSectionsLoaded = true;

  function cssUrl(value) {
    return "url('" + String(value).replace(/['\\()]/g, '') + "')";
  }

  function apply(radio) {
    if (!radio) return;
    var tile = radio.getAttribute('data-tile') || '';
    var url = radio.getAttribute('data-panel-url') || '';
    var name = radio.getAttribute('data-name') || '';
    if (tile) {
      var painted = cssUrl(tile);
      document.querySelectorAll('[data-pv-tile-target]').forEach(function (node) {
        node.style.setProperty('--pv-tile', painted);
      });
    }
    document.querySelectorAll('[data-pv-follow]').forEach(function (node) {
      if (url) node.setAttribute('href', url);
    });
    document.querySelectorAll('[data-pv-name-target]').forEach(function (node) {
      if (name) node.textContent = name;
    });
  }

  function track(placement, handle) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'pv_panel_cta',
        placement: placement || '',
        product_handle: handle || ''
      });
    } catch (e) {}
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches || !radio.matches('[data-pv-print]')) return;
    apply(radio);
  });

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-pv-track]') : null;
    if (!link) return;
    track(link.getAttribute('data-pv-track'), link.getAttribute('data-pv-handle') || '');
  });

  var checked = document.querySelector('[data-pv-print]:checked') || document.querySelector('[data-pv-print]');
  apply(checked);
})();
